import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PermissionsOnboardingComponent } from './permissions-onboarding.component';

@NgModule({
	declarations: [
		PermissionsOnboardingComponent
	],
	imports: [
		CommonModule,
		IonicModule
	],
	exports: [
		PermissionsOnboardingComponent
	]
})
export class PermissionsOnboardingComponentModule { }
